import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import useWindowSize from '@hooks/use-window-size';
import { useBucket } from '@context/bucket.context';
import { isWebview, isCatalogOrCampaignPage, isHomePage } from '@helpers/routing';
import { getVisitorIdentityFromCookie } from '@helpers/utils/visitor-identity-cookie';
import { shouldEvaluateStickyNavFF } from '@helpers/utils/sticky-nav/sticky-nav-utils';
import StickyEntrypointNav from './sticky-entrypoint-nav';

const StickyEntrypointNavWrapper: React.FC = () => {
  const router = useRouter();
  const { pathname, asPath, query } = router;
  const { isFeatureEnabled } = useBucket();
  const { isWiderThanMd, hasWindowSizeBeenSet } = useWindowSize();
  const [windowWidth, setWindowWidth] = useState<number | null>(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setWindowWidth(window.innerWidth);
    }
  }, []);

  // If window size hasn't been set yet, check width directly (fallback for iOS simulator)
  // Otherwise use the calculated isMobile value
  // md breakpoint is 768px (from DEVICE_SIZES.md in use-window-size.ts)
  const isMobile = !hasWindowSizeBeenSet ? (windowWidth !== null && windowWidth < 768 ? true : null) : !isWiderThanMd;
  const visitorIdentity = getVisitorIdentityFromCookie();
  const isWebView = isWebview(query);

  const shouldEvalFF = shouldEvaluateStickyNavFF({
    isMobile,
    visitorType: visitorIdentity?.visitorType,
    isWebView: isWebView || query.webview === '1' || query.native === '1',
    pathname,
    hasFromStickyNav: query.fromStickyNav === '1',
  });

  if (!shouldEvalFF) {
    return null;
  }

  const isStickyNavEnabled = isFeatureEnabled((f) => f.enableMultiCatStickyEntrypointNav, true);
  if (!isStickyNavEnabled) {
    return null;
  }

  const isCatalogOrCampaign = isCatalogOrCampaignPage(pathname);
  const shouldShowOnHomepage = isHomePage(pathname, asPath) && isMobile === true;
  const shouldShowOnCatalogOrCampaign = isCatalogOrCampaign && query.fromStickyNav === '1' && isMobile === true;

  if (!shouldShowOnHomepage && !shouldShowOnCatalogOrCampaign) {
    return null;
  }
  return <StickyEntrypointNav />;
};

export default StickyEntrypointNavWrapper;
